import script from "./AppHeaderInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderInfo.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderInfo.vue?vue&type=style&index=0&id=348c3dc4&lang=scss"

const __exports__ = script;

export default __exports__